import type { NormalisedUser } from "@onhandtech/onhand-fe-shared/lib/api/v4/user";
import type { NormalisedVolunteerGroup } from "@onhandtech/onhand-fe-shared/lib/api/v4/volunteer-group/volunteer-group.types";
import type { NormalisedRequestFilterSet } from "@onhandtech/onhand-fe-shared/lib/api/v5/request-filter-set/request-filter-set.types";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { Action } from "redux";

import slice from "./sections.slice";
import { moduleName } from "./sections.types";

export const actionTypes = {
	SAVE_SECTION: `${moduleName}/SAVE_SECTION`,
	ADD_PERMISSION_ASSIGNMENT: `${moduleName}/ADD_PERMISSION_ASSIGNMENT`,
	ADD_PUBLIC_PERMISSION_ASSIGNMENT: `${moduleName}/ADD_PUBLIC_PERMISSION_ASSIGNMENT`,
	UNPUBLISH_SECTION: `${moduleName}/UNPUBLISH_SECTION`,
};

const {
	setSelectedSection,
	addFilter,
	removeFilter,
	clearFilters,
	reorderFilters,
	setActiveFilterType,
	setSectionModal,
	setAutomaticallyRemovingPublicPermission,
	setPageNumber,
} = slice.actions;

const saveSection = (): Action => ({
	type: actionTypes.SAVE_SECTION,
});

export type AddPermissionAssignmentPayload = {
	target: NormalisedUser | NormalisedVolunteerGroup;
};

const addPermissionAssignment = (
	target: NormalisedUser | NormalisedVolunteerGroup,
): PayloadAction<AddPermissionAssignmentPayload> => ({
	type: actionTypes.ADD_PERMISSION_ASSIGNMENT,
	payload: {
		target,
	},
});

const addPublicPermissionAssignment = (): Action => ({
	type: actionTypes.ADD_PUBLIC_PERMISSION_ASSIGNMENT,
});

export type UnpublishSectionActionPayload = {
	section: NormalisedRequestFilterSet;
};

const unpublishSection = (
	section: NormalisedRequestFilterSet,
): PayloadAction<UnpublishSectionActionPayload> => ({
	type: actionTypes.UNPUBLISH_SECTION,
	payload: {
		section,
	},
});

export {
	addFilter,
	addPermissionAssignment,
	addPublicPermissionAssignment,
	clearFilters,
	removeFilter,
	reorderFilters,
	saveSection,
	setActiveFilterType,
	setAutomaticallyRemovingPublicPermission,
	setPageNumber,
	setSectionModal,
	setSelectedSection,
	unpublishSection,
};
